export const EIMBURSEMENT_ACCOUNT_LOGIN_REQUIRED =
  'REIMBURSEMENT_ACCOUNT_LOGIN_REQUIRED'
export const REIMBURSEMENT_LOGIN_WRONG_CREDENTIALS =
  'REIMBURSEMENT_LOGIN_WRONG_CREDENTIALS'
export const REIMBURSEMENT_ACCOUNT_NOT_FOUND = 'REIMBURSEMENT_ACCOUNT_NOT_FOUND'
